import { DocumentsListItem } from './DocumentsListItem';
import PropTypes from 'prop-types';
import React from 'react';

const renderList = (documents, backLink) => (
    <div>
        {documents.length ? (
            <ul className="list-group list-group-flush">
                {documents.map(document => renderListItem(document, backLink))}
            </ul>
        ) : (
            <div className="pb-3" />
        )}
    </div>
);

const renderListItem = (document, backLink) => (
    <li key={document.url} className="list-group-item">
        <DocumentsListItem {...document} backLink={backLink} />
    </li>
);

const DocumentsList = props => renderList(props.documents, props.backLink);

DocumentsList.propTypes = {
    documents: PropTypes.array.isRequired,
    backLink: PropTypes.string,
};

export { DocumentsList };
